
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '单据名称',
value: this.$route.params.PI_NAME
}, {
label: '来源部门',
value: this.$route.params.PI_DEP
}, {
label: '是否合并',
value: this.$route.params.PI_ISMERGE
}, {
label: '代码',
value: this.$route.params.PI_CODE
}, {
label: '单据要求',
value: this.$route.params.PI_REMARK
}, {
label: '注释',
value: this.$route.params.PI_DES
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_InvoicesDetail.vue